<template>
  <div
    class="shelf-box"
    v-loading="loading"
    element-loading-text="拼命加载中">

    <div style="margin-bottom: 0.8rem;text-align: center"><h2>扫描货架条码</h2></div>
    <el-form class="search-box" ref="form" :model="form" :rules="rules">
      <el-form-item prop="order_number">
        <el-input
          ref="search"
          @focus="stopKeyborad"
          @blur="stopKeyborad"
          v-model="form.shelf_no"
          @keydown.enter.native.prevent="onSubmit(1)"
          placeholder="扫描需要上架的货架条码"
        >
          <el-button
            @click.prevent="onSubmit(1)"
            slot="append"
            icon="el-icon-search"
          ></el-button>
        </el-input>
      </el-form-item>
    </el-form>


    <div class="show">
      <div class="line">
        <el-row>

          <el-col :span="24">
            <div class="grid-content bg-purple-light">
              <h3>订单号:</h3>
              <!--<p><span style="font-weight: bold">订单号</span>: <span style="color: red">{{ order.order_number }}</span></p>-->
              <p style="text-align: center"><span style="color: red" v-if="Object.keys(order).length">{{ order.order_number }}</span></p>
            </div>
          </el-col>

          <el-col :span="24">
            <div class="grid-content bg-purple-light">
              <h3>货架号:</h3>
              <!--<p><span style="font-weight: bold">货架号</span>: <span style="color: red">{{ order.shelves_pending.shelf_no }}</span></p>-->
              <p style="text-align: center"><span style="color: red" v-if="Object.keys(order).length">{{ order.shelf_no }}</span></p>
            </div>
          </el-col>
        </el-row>
      </div>

    </div>


    <div class="check-box">
      <el-form ref="form" :model="form" label-width="50px">
        <el-form-item label="货架">
          <el-select v-model="form.shelf_id" placeholder="请选择货架号">
            <template v-for="item of shelves">
              <template v-if="item.order_count>=100">
                <!--<el-option :key="item.id" :label="item.shelf_no+' &#45;&#45;'+item.order_count+' 已满'" :value="item.id" disabled></el-option>-->
                <el-option :key="item.id" :label="item.shelf_no+'   已满'" :value="item.id" disabled></el-option>
              </template>
              <template v-else>
                <el-option :key="item.id" :label="item.shelf_no" :value="item.id"></el-option>
                <!--<el-option :key="item.id" :label="item.shelf_no+' &#45;&#45;'+item.order_count+'&#45;&#45;'" :value="item.id"></el-option>-->
              </template>
            </template>
            <!--<el-option label="LSA14" value="2"></el-option>-->
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <el-row class="button-box">
      <el-button style="margin-bottom: 1rem" type="primary" @click.prevent="onSubmit(2)">完成</el-button>
    </el-row>

    <div class="wav">
      <audio id="audioMusic" class="audio" src="@/assets/wav/didi.wav" controls hidden="true" ref="audio"></audio>
      <audio id="failMusic" class="audio" src="@/assets/wav/yichang.wav" controls hidden="true" ref="audio"></audio>
    </div>

  </div>
</template>

<script>
export default {
  name: "Form",
  data() {
    return {
      order: {},
      loading: false,
      shelves: [],
      form: {
        shelf_no: "",
        shelf_id: ''
      },
      rules: {
        shelf_no: [
          {required: false, message: "扫描货架条码", trigger: "blur"},
          /*{
            type: "number",
            message: "请输入正确的订单编号",
            trigger: ["blur", "change"],
          },*/
        ],
      },

    }
  },
  methods: {

    latestSecurityIncidents() {
      //同时 触发提示音
      document.getElementById('audioMusic').play();
    },

    failMusic() {
      document.getElementById('failMusic').play();
    },

    onSubmit(s) {

      if (s === 1) {
        // this.latestSecurityIncidents()
        if (!this.form.shelf_no) {
          const h = this.$createElement;
          this.$message({
            offset: 50,
            duration: 3000,
            message: h('p', null, [
              h('span', null, '请扫描货架条码 '),
              // h('i', { style: 'color: teal' }, 'VNode')
            ])
          });
          return false;
        }
      }

      if (s === 2) {
        // this.failMusic()
        if (!this.form.shelf_id) {
          const h = this.$createElement;
          this.$message({
            offset: 50,
            duration: 3000,
            message: h('p', null, [
              h('span', null, '请选择货架 '),
              // h('i', { style: 'color: teal' }, 'VNode')
            ])
          });
          return false;
        }
      }

      let param = {

        order_number: this.order.order_number,
        shelf_no: this.form.shelf_no,
        shelf_id: this.form.shelf_id
      }

      console.log(param);
      this.http.fetchPost(this.api.pendingCreate, param).then((res) => {
        // console.log(res)
        let data = res.data
        if (data.code === 200) {

          this.latestSecurityIncidents()

          const h = this.$createElement;
          this.$message({
            offset: 50,
            duration: 1000,
            message: h('p', null, [
              h('span', null, '提交成功 '),
              // h('i', { style: 'color: teal' }, 'VNode')
            ])
          });
          let _this = this
          setTimeout(function () {
            _this.$router.push({
              path: "/pending",
              /*query: {
                order_number: _this.order.order_number
              }*/

            })
          }, 1000)

        } else {
          this.failMusic()
          const h = this.$createElement;
          this.$message({
            offset: 50,
            duration: 2000,
            message: h('p', null, [
              h('span', null, data.message),
              // h('i', { style: 'color: teal' }, 'VNode')
            ])
          });
        }
      }).catch(err => {
        console.log(err)
      })

    },

    getShelf() {
      this.http.fetchGet(this.api.getPendingShelfUrl).then((res) => {
        let data = res.data
        if (data.code === 200) {

          this.shelves = data.data


        } else {
          this.$message.error("获取仓库列表失败,请刷新页面")
        }
      }).catch(err => {
        console.log(err)
      })
    },

    //自动获取光标
    onfocusEvent() {
      this.$refs.search.focus()
    },
    stopKeyborad(e) {
      //尝试一下
      e.target.setAttribute('readonly', true);
      setTimeout(() => {
        e.target.removeAttribute('readonly');
      }, 100);
    },


  },

  mounted() {
    this.getShelf()
    this.onfocusEvent()
  },

  created() {
    let _this = this
    this.$EventBus.$off("order").$on("order", res => {
      console.log(res)
      _this.order = res;
      _this.form.shelf_id = _this.order.shelf_id;
    })
  },
}
</script>

<style scoped lang="stylus">

.shelf-box
  background-color #f8f8d0
  padding 10px
  position absolute
  top 0
  left 0
  right 0
  bottom 0

.show {
  //float: left;
  width: 100%;

  .line {
    box-sizing: border-box;
    border: 1px solid black;
    //margin-top: 1rem;
    margin: 1px;
    //float: left;
    width: 100%;

    .el-col {
      margin-top 5px
      margin-bottom: 20px;
      padding 0 5px

      font-size 2rem

    }

    .grid-content {
      //text-align center

      h3 {
        font-size 1.5rem
      }
    }

  }
}


.check-box {
  margin-top 2rem

  .el-select {
    width 100%
  }
}

.button-box
  text-align center


</style>
